import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "title-message" }, [
  /*#__PURE__*/_createTextVNode(" 国立国会図書館では、"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.ndl.go.jp/jp/collect/online/index.html",
    target: "_blank"
  }, "オンライン資料収集制度（eデポ）"),
  /*#__PURE__*/_createTextVNode("に基づき、電子書籍・電子雑誌（オンライン資料）を収集しています。電子書籍・電子雑誌を出版した方（出版社、団体、個人等）は、以下の方法で納入の手続をお願いいたします。 ")
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}